import styled from 'styled-components';

export const SCAlertBox = styled.div`
  background-color: ${p => p.theme.rgba('red', 0.05)};
  border: 1px solid ${p => p.theme.color.gray};
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 20px ${p => p.theme.base.spacing.large} 20px;
  margin: 15px 0;
`;

export const Header = styled.h4`
  margin: 0px 0px 0px 0px;
`;

export const Text = styled.p`
  margin: ${p => p.theme.base.spacing.small} 0px 0px 0px;
`;

export const RejectBox = styled.div`
  display: flex;
  flex-direcion: row;
  padding-top: ${p => p.theme.base.spacing.large};
`;

export const TextBox = styled.div`
  margin-left: ${p => p.theme.base.spacing.regular};
`;

export const AdminImage = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: url(${p => p.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;



// WEBPACK FOOTER //
// ./src/components/AlertBox/styles.js